module.exports = __webpack_public_path__ + "img/s2-hx-7.88fd637c.png";